<template>
  <div class="invoices-list page page-with-table p-2">
    <page-header class="mb-2">
      <template v-slot:title>
        <div style="flex: 1">
          <h1 class="mb-0">{{ $t('Shipping') }}</h1>
        </div>
      </template>
    </page-header>
    <div class="card content-wrapper">
      <InvoicesTable :excludeColumns="['amount', 'paid_at']" :hide-actions="hideActions"
                     :exclude-types-from-filter="['service', 'credit_note']" :hide-action-buttons="hideActionButtons"/>
    </div>
  </div>
</template>

<script>
  import InvoicesTable from "../../invoices/InvoicesTable";
  import {createNamespacedHelpers} from "vuex";
  import PageHeader from "@/core/components/page-header/PageHeader";
  import {
    ACTION_BATCH_INVOICE_GENERATE,
    ACTION_CANCEL_INVOICE,
    ACTION_CREATE_DEPOSIT_INVOICE,
    ACTION_CREATE_MANUAL_INVOICE,
    ACTION_CREATE_NEW_INVOICE,
    ACTION_PAY_INVOICE,
    ACTION_REFUND_INVOICE,
    ACTION_SEND_OVERDUE_EMAILS,
    ACTION_SEND_SECOND_OVERDUE_EMAILS,
    ACTION_SEND_THIRD_OVERDUE_EMAILS,
    ACTION_SEND_UNPAID_EMAILS,
    ACTION_BATCH_SHIPPING_CHARGES,
    ACTION_SHOW_INVOICE_PAYMENTS_MODAL,
    ACTION_SYNC_WITH_ACCOUNTING_SYSTEM
  } from "@/modules/constants";

  const {mapActions: invoicesMapActions} = createNamespacedHelpers('invoices');

  export default {
    name: "Shipping",
    components: {PageHeader, InvoicesTable},
    methods: {
      ...invoicesMapActions(['updateTableSource']),
    },
    data: function () {
      return {
        hideActions: [
          ACTION_SEND_OVERDUE_EMAILS,
          ACTION_SEND_SECOND_OVERDUE_EMAILS,
          ACTION_SEND_THIRD_OVERDUE_EMAILS,
          ACTION_SEND_UNPAID_EMAILS,
          ACTION_CREATE_NEW_INVOICE,
          ACTION_CREATE_MANUAL_INVOICE,
          ACTION_CREATE_DEPOSIT_INVOICE,
          ACTION_BATCH_INVOICE_GENERATE,
          ACTION_CANCEL_INVOICE,
          ACTION_PAY_INVOICE,
          ACTION_REFUND_INVOICE,
          ACTION_SYNC_WITH_ACCOUNTING_SYSTEM,
          ACTION_BATCH_SHIPPING_CHARGES,
        ],
        hideActionButtons: [
          ACTION_SHOW_INVOICE_PAYMENTS_MODAL
        ]
      }
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'shipping',
        extraFilters: {type: 'manual,auction', shipping_status: 'paid,unpaid,cancelled'}
      });
    },
  }
</script>

<style scoped lang="scss">
  @import "./scss/variables.scss";

  .invoices-list {
    @include list-view-wrapper;
  }
</style>
